import { render } from "./DetailImageView.vue?vue&type=template&id=bfd1a4c6&scoped=true&ts=true"
import script from "./DetailImageView.vue?vue&type=script&lang=ts"
export * from "./DetailImageView.vue?vue&type=script&lang=ts"

import "./DetailImageView.vue?vue&type=style&index=0&id=bfd1a4c6&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd1a4c6"]])

export default __exports__